module.exports = __webpack_public_path__ + "img/gc_country_flag_lt.381709d6.svg";